import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
interface Props {
  data: any;
}
export default function MuiAccordion({ data }: Props) {
  return (
    <div>
      {data?.map((item: any, index: number) => (
        <Accordion
          sx={{
            boxShadow: "none",
            marginBottom: 0,
          }}
          key={index}
        >
          <AccordionSummary
            expandIcon={
              <i className="fa-solid fa-angle-down text-indigo-700"></i>
            }
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{
              borderBottom: "1px solid #e7e7e7",
              padding: 0,
              justifyContent: "start",
              "& .MuiAccordionSummary-content": {
                flexGrow: "0",
                padding: "0 5px 0px 0",
              },
            }}
          >
            <Typography component="span" className="text-indigo-700">
              <strong>{item?.title}</strong>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>{item?.content}</AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}
